import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { faTag, faTimes, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Tag } from '../../services/tags.service';

@Component({
  selector: 'app-modal-tag-details',
  standalone: true,
  imports: [FontAwesomeModule, TranslateModule],
  templateUrl: './modal-tag-details.component.html',
  styleUrls: ['./modal-tag-details.component.scss']
})
export class ModalTagDetailsComponent {
  @Input() show = false;
  @Input() tag: Tag | null = null;
  @Output() close = new EventEmitter<void>();

  faTag = faTag;
  faTimes = faTimes;
  faInfoCircle = faInfoCircle;

  onClose() {
    this.close.emit();
  }
}
